/**
 * These groups correspond with the groups that are used
 * with UX/VD inside Figma.
 */
import * as buttonTypography from './button';
import * as captionTypography from './caption';
import * as dateTypography from './date';
import * as formTypography from './form';
import * as headingTypography from './heading';
import * as labelTypography from './label';
import * as miscTypography from './misc';
import * as numberTypography from './number';
import * as paragraphTypography from './paragraph';
import * as pricesTypography from './prices';
import * as stickerTypography from './sticker';
import * as uspTypography from './usp';
export * from './button';
export * from './label';
export * from './heading';
export * from './paragraph';
export * from './caption';
export * from './form';
export * from './number';
export * from './prices';
export * from './date';
export * from './usp';
export * from './sticker';
export * from './misc';
// This configurations object is used so the files can be loaded as a side effect.
export const configurations = {
    buttonTypography,
    labelTypography,
    headingTypography,
    paragraphTypography,
    captionTypography,
    formTypography,
    numberTypography,
    pricesTypography,
    dateTypography,
    uspTypography,
    stickerTypography,
    miscTypography,
};
